import { atom } from "recoil";

export const alarmState = atom({
    key: "alarmState",
    default: "off", // 'on' 또는 'off'
});